import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.Reports.heading',
    defaultMessage: 'Raporty okresowe'
  },
  allReports: {
    id: 'views.Reports.allReports',
    defaultMessage: 'Wszystkie'
  },
  reports: {
    id: 'views.Reports.reports',
    defaultMessage: 'Raporty'
  },
  yearlyReports: {
    id: 'views.Reports.yearlyReports',
    defaultMessage: 'Raporty roczne'
  },
  yearlyReportsBeforeStockExchange: {
    id: 'views.Reports.yearlyReportsBeforeStockExchange',
    defaultMessage: 'Raporty roczne publikowane przed debiutem giełdowym'
  },
  quarterlyReports: {
    id: 'views.Reports.quarterlyReports',
    defaultMessage: 'Raporty kwartalne'
  },
  categories: {
    id: 'views.Reports.categories',
    defaultMessage: 'KATEGORIE'
  },
  reportForYear: {
    id: 'views.Reports.categories.reportForYear',
    defaultMessage: 'Raporty {year} r.'
  },
  year: {
    id: 'views.Reports.categories.year',
    defaultMessage: '{year} rok:'
  }
});



// WEBPACK FOOTER //
// ./src/views/Reports/ReportsView.intl.js